import React from 'react'

import { Player } from 'video-react'

import {
    EuiText,
    EuiTitle,
    EuiIcon,
    EuiPanel
  } from '@elastic/eui'

import { OutboundLink } from 'gatsby-plugin-gtag'

require('../../../Layout/chrome/assets/video.css')

function VideoCard() {
  return (
    <EuiPanel paddingSize="m">
        <EuiTitle size="s"><h4>Objektivjustage</h4></EuiTitle>
        <Player>
        <source src="https://wiki.instar.com/videos/Objektiv_scharfstellen_IN9008FullHD.mp4" />
        </Player>
        <EuiText>
            <p>Objektiv scharfstellen IN-9008FullHD. Auf <OutboundLink href="https://www.youtube.com/watch?v=DDXWICprHwA" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
        </EuiText>
    </EuiPanel>
  );
}

export default VideoCard